module.exports = __webpack_public_path__ + "img/397.7acd3437.png";